/* AR Home — shared interactivity (ar-home-* sections)
 * Idempotent: safe to include from multiple sections; runs init once. */
(function(){
  if(window.__arhLoaded){return;}
  window.__arhLoaded=true;

  function init(){
    /* Scroll reveal */
    if(!window.matchMedia('(prefers-reduced-motion:reduce)').matches){
      var els=document.querySelectorAll('.arh-reveal:not(.arh-reveal--visible)');
      if(els.length){
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){e.target.classList.add('arh-reveal--visible');io.unobserve(e.target);}
          });
        },{threshold:0.06,rootMargin:'0px 0px -60px 0px'});
        els.forEach(function(el){io.observe(el);});
      }
    }

    /* YouTube facade — click + keyboard */
    document.querySelectorAll('.arh-video__play[data-yt]').forEach(function(btn){
      if(btn.__arhBound)return;btn.__arhBound=true;
      function play(){
        var id=btn.dataset.yt,wrap=btn.closest('.arh-video__wrap');
        if(!wrap)return;
        wrap.innerHTML='<iframe src="https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0" allow="autoplay;encrypted-media" allowfullscreen style="width:100%;height:100%;position:absolute;inset:0;border:0"></iframe>';
      }
      btn.addEventListener('click',play);
      btn.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();play();}});
    });

    /* Sticky mobile CTA — show after hero exits, hide near footer, respect dismiss */
    var mcta=document.getElementById('arh-mcta');
    if(mcta&&!mcta.__arhBound){
      mcta.__arhBound=true;
      var dismissed=false;
      try{dismissed=sessionStorage.getItem('arh_mcta_dismissed')==='1';}catch(e){}
      if(!dismissed){
        var hero=document.querySelector('.arh-hero');
        var tail=document.querySelector('.arh-manifesto')||document.querySelector('.arh-news');
        var heroVisible=true,tailVisible=false;
        var update=function(){
          if(!heroVisible&&!tailVisible){mcta.classList.add('arh-mcta--visible');}
          else {mcta.classList.remove('arh-mcta--visible');}
        };
        if(hero){
          new IntersectionObserver(function(es){es.forEach(function(e){heroVisible=e.isIntersecting;update();});},{threshold:0,rootMargin:'-60px 0px 0px 0px'}).observe(hero);
        } else {heroVisible=false;update();}
        if(tail){
          new IntersectionObserver(function(es){es.forEach(function(e){tailVisible=e.isIntersecting;update();});},{threshold:0}).observe(tail);
        }
      }
      var dismissBtn=mcta.querySelector('[data-arh-mcta-dismiss]');
      if(dismissBtn){
        dismissBtn.addEventListener('click',function(){
          mcta.classList.remove('arh-mcta--visible');
          try{sessionStorage.setItem('arh_mcta_dismissed','1');}catch(e){}
        });
      }
    }

    /* Affirm As-Low-As refresh — theme's affirmShopify.js loads window.affirm; poll briefly then refresh */
    if(!window.__arhAffirmTicked){
      window.__arhAffirmTicked=true;
      var hasAffirmNodes=document.querySelector('.affirm-as-low-as[data-amount]');
      if(hasAffirmNodes){
        var tries=0,maxTries=40;
        var affirmTick=setInterval(function(){
          tries++;
          if(window.affirm&&window.affirm.ui&&typeof window.affirm.ui.refresh==='function'){
            try{window.affirm.ui.refresh();}catch(e){}
            clearInterval(affirmTick);
          } else if(tries>=maxTries){clearInterval(affirmTick);}
        },250);
      }
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }

  /* Re-init on Shopify theme editor block additions/reorder */
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:reorder',init);
})();


/* AR Home - Product Cards slider (full-bleed swipe + optional autoplay) */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initSlider(root) {
    if (root.dataset.arhSliderReady) return;
    var track = root.querySelector('[data-arh-prodslider-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.arh-prod'));
    root.dataset.arhSliderReady = '1';
    if (slides.length < 2) return;
    var prev = root.querySelector('[data-arh-prodslider-prev]');
    var next = root.querySelector('[data-arh-prodslider-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-arh-prodslider-dot]'));
    var current = 0;

    /* Autoplay config, read from section settings via data-attrs. Off for reduced-motion. */
    var autoplay = root.getAttribute('data-arh-autoplay') !== 'false' && !reduceMotion;
    var intervalMs = parseInt(root.getAttribute('data-arh-autoplay-ms'), 10) || 6000;
    if (intervalMs < 2500) intervalMs = 2500;
    var timer = null;
    var inView = !('IntersectionObserver' in window);
    var hovering = false, focused = false, pressing = false;

    function update() {
      for (var i = 0; i < dots.length; i++) {
        var on = i === current;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= slides.length - 1;
    }
    function go(i) {
      current = Math.max(0, Math.min(slides.length - 1, i));
      update();
      track.scrollTo({ left: current * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    /* Autoplay engine: runs only while visible, idle, and tab is foregrounded. */
    function shouldRun() {
      return autoplay && inView && !hovering && !focused && !pressing && !document.hidden;
    }
    function sync() {
      if (shouldRun()) { if (!timer) timer = setInterval(tick, intervalMs); }
      else if (timer) { clearInterval(timer); timer = null; }
    }
    function tick() { go(current >= slides.length - 1 ? 0 : current + 1); }
    function bump() { if (timer) { clearInterval(timer); timer = null; } sync(); }

    if (prev) prev.addEventListener('click', function () { go(current - 1); bump(); });
    if (next) next.addEventListener('click', function () { go(current + 1); bump(); });
    for (var d = 0; d < dots.length; d++) {
      (function (idx) { dots[idx].addEventListener('click', function () { go(idx); bump(); }); })(d);
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; update(); }
      });
    }, { passive: true });

    if (autoplay) {
      root.addEventListener('pointerenter', function () { hovering = true; sync(); });
      root.addEventListener('pointerleave', function () { hovering = false; sync(); });
      root.addEventListener('focusin', function () { focused = true; sync(); });
      root.addEventListener('focusout', function () { focused = false; sync(); });
      root.addEventListener('pointerdown', function () { pressing = true; sync(); }, { passive: true });
      window.addEventListener('pointerup', function () { if (pressing) { pressing = false; bump(); } }, { passive: true });
      document.addEventListener('visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }, { threshold: 0.2 }).observe(root);
      } else {
        sync();
      }
    }

    update();
  }
  function initAllSliders() {
    var nodes = document.querySelectorAll('[data-arh-prodslider]');
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllSliders);
  else initAllSliders();
  document.addEventListener('shopify:section:load', initAllSliders);
})();
